<template>
  <!-- Small status pill used under the URL field for validation / human-check
       feedback. Dot color reflects `state`: error (red), warning (yellow),
       success (green). -->
  <span
    v-if="state"
    class="mt-2 inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-white ring-1 ring-inset ring-gray-800"
  >
    <svg :class="dotClass" viewBox="0 0 6 6" aria-hidden="true">
      <circle cx="3" cy="3" r="3" />
    </svg>
    {{ displayMessage }}
  </span>
</template>

<script setup>
import { computed } from 'vue'
import { toDisplayError } from '~/utils/errorMessage'

const props = defineProps({
  // '' | 'error' | 'warning' | 'success'
  state: { type: String, default: '' },
  // Expected to be a display-ready string; anything else is normalised below.
  message: { type: [String, Object], default: '' },
})

// Last line of defence for the pill: this is the single element every status
// message renders through, so it is also the last place an Error object or a
// raw response body could leak into the page (an HTML error page rendered here
// is exactly the bug utils/errorMessage.ts exists to prevent). Vue's
// interpolation would happily print `String(error)` — the whole document
// included — so nothing reaches the DOM without being sanitised first.
const displayMessage = computed(() => {
  const raw = props.message
  if (raw == null || raw === '') return ''
  return toDisplayError(raw)
})

const dotClass = computed(() => {
  if (props.state === 'error') return 'h-1.5 w-1.5 fill-red-400'
  if (props.state === 'warning') return 'h-1.5 w-1.5 fill-yellow-400'
  return 'h-1.5 w-1.5 fill-emerald-400'
})
</script>
